package feature.product.event

class ProductEvent {
    companion object {
        const val CREATE = "CREATE_PRODUCT"
        const val UPDATE = "UPDATE_PRODUCT"
        const val RETRIEVE = "RETRIEVE_PRODUCT"
        const val DELETE = "DELETE_PRODUCT"
        const val UPDATE_IMAGE = "UPDATE_PRODUCT_IMAGE"
        const val CREATE_PRICE = "CREATE_PRODUCT_PRICE"
        const val UPDATE_PRICE = "UPDATE_PRODUCT_PRICE"
    }
}